import React, { useState } from "react";
import "../css/main.scss";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const carouselImages = [
  "/editorial/hero-1.png",
  "/editorial/hero-2.png",
  "/editorial/hero-3.png",
  "/editorial/hero-4.png",
];

function Main() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide
      ? carouselImages.length - 1
      : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === carouselImages.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="main">
      <div className="carousel-wrapper">
        <div className="carousel-container">
          <div className="carousel-arrow left-arrow" onClick={prevSlide}>
            <FiChevronLeft strokeWidth={1} />
          </div>

          <div
            className="carousel-slide"
            style={{ backgroundImage: `url(${carouselImages[currentIndex]})` }}
          ></div>

          <div className="carousel-arrow right-arrow" onClick={nextSlide}>
            <FiChevronRight strokeWidth={1} />
          </div>
        </div>
      </div>

      <section className="home-intro" aria-labelledby="home-intro-title">
        <p className="home-kicker">pmistpearl · Hong Kong</p>
        <h1 id="home-intro-title">Pearls for the moments between occasions.</h1>
        <p>
          Our collection brings together freshwater pearl jewellery with clean lines,
          comfortable proportions and an easy sense of polish. Each style is selected
          to feel special without waiting for a special day.
        </p>
        <Link to="/shop" onClick={toTop} className="home-text-link">Explore the collection <span aria-hidden="true">→</span></Link>
      </section>

      <section className="home-categories" aria-label="Shop pearl jewellery by category">
        <article><span>01</span><h2>Necklaces</h2><p>Fine chains, luminous pendants and softly layered pearl strands.</p><Link to="/shop" onClick={toTop}>Shop necklaces</Link></article>
        <article><span>02</span><h2>Earrings</h2><p>Petite studs, light-catching drops and modern pearl details.</p><Link to="/shop" onClick={toTop}>Shop earrings</Link></article>
        <article><span>03</span><h2>Bracelets &amp; rings</h2><p>Easy pieces designed to combine, stack and wear your own way.</p><Link to="/shop" onClick={toTop}>Shop the collection</Link></article>
      </section>

      <section className="home-story" aria-labelledby="home-story-title">
        <div>
          <p className="home-kicker">Naturally individual</p>
          <h2 id="home-story-title">No two pearls are exactly alike.</h2>
        </div>
        <div>
          <p>Small variations in shape, surface and lustre are part of a freshwater pearl's character. We inspect every style in Hong Kong and choose pieces that balance this natural individuality with thoughtful, wearable design.</p>
          <Link to="/about" onClick={toTop} className="home-text-link">Discover our story <span aria-hidden="true">→</span></Link>
        </div>
      </section>

      <section className="home-notes" aria-label="Shopping information">
        <article><h3>Considered selection</h3><p>Every style is reviewed for finish, proportion and everyday comfort.</p></article>
        <article><h3>Tracked delivery</h3><p>Orders are carefully packed in Hong Kong with tracked shipping for USD 9.99.</p></article>
        <article><h3>Here to help</h3><p>Questions about a piece or an order? Write to service@pmistpearl.work.</p></article>
      </section>

      <section className="home-care" aria-labelledby="home-care-title">
        <p className="home-kicker">A little care goes a long way</p>
        <h2 id="home-care-title">Keep your pearls close, and treat them gently.</h2>
        <p>Wear them often, keep them dry, and wipe them softly after use. Store each piece separately to protect its finish and natural lustre.</p>
        <Link to="/faqs" onClick={toTop} className="home-text-link">Read pearl care FAQs <span aria-hidden="true">→</span></Link>
      </section>
    </div>
  );
}

export default Main;
